// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import axios from 'axios'
import App from './App'
import { router, routerTrials } from './router'
import store from './store'
import VModal from 'vue-js-modal'
import Notifications from './services/notifications'

axios.defaults.validateStatus = (status) => {
  return status < 400
}

let prevSessionCheck = new Date().getTime()

const checkSession = async () => {
  const now = new Date().getTime()
  if (now - prevSessionCheck > 60000 && store.state.user.loaded) {
    await axios.post(
      `${store.state.config.API_URL}/users/checkSession`,
      undefined,
      {
        headers: {
          Authorization: `Bearer ${store.state.user.token}`
        }
      })
  }
  setTimeout(() => {
    if (store.state.user.token) {
      checkSession()
    }
  }, 60000)
}

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (store.state.auth && error.response && error.response.status === 401) {
      return store.state.auth.logout()
    } else {
      return Promise.reject(error)
    }
  }
)

axios.interceptors.request.use(
  async (request) => {
    if (request.url.includes('/users/checkSession')) {
      prevSessionCheck = new Date()
    }
    if (request.url.includes('/graphql') && store.state.user.loaded) {
      try {
        await axios.post(
          `${store.state.config.API_URL}/users/checkSession`,
          undefined,
          {
            headers: {
              Authorization: `Bearer ${store.state.user.token}`
            }
          })
        return request
      } catch (e) {
        return store.state.auth.logout()
      }
    } else {
      return request
    }
  }
)

checkSession()

Vue.config.productionTip = false

Vue.prototype.$notifications = new Notifications()

Vue.directive('click-outside', {
  bind: function (el, binding, vNode) {
    // Provided expression must evaluate to a function.
    if (typeof binding.value !== 'function') {
      const compName = vNode.context.name
      let warn = `[Vue-click-outside:] provided expression '${binding.expression}' is not a function, but has to be`
      if (compName) { warn += `Found in component '${compName}'` }

      console.warn(warn)
    }
    // Define Handler and cache it on the element
    const bubble = binding.modifiers.bubble
    const handler = (e) => {
      if (bubble || (!el.contains(e.target) && el !== e.target)) {
        binding.value(e)
      }
    }
    el.__vueClickOutside__ = handler

    // add Event Listeners
    document.addEventListener('click', handler)
  },

  unbind: function (el, binding) {
    // Remove Event Listeners
    document.removeEventListener('click', el.__vueClickOutside__)
    el.__vueClickOutside__ = null
  }
})

const isPortal = !location.hostname.includes('trials')

/* eslint-disable no-new */
Vue.use(VModal)
new Vue({
  el: '#app',
  router: isPortal ? router : routerTrials,
  store,
  render: h => h(App)
})

// IE11 remove element polyfill
if (!Element.prototype.remove) {
  Element.prototype.remove = function () {
    this.parentElement.removeChild(this)
  }
}
if (!NodeList.prototype.remove) {
  NodeList.prototype.remove = HTMLCollection.prototype.remove = function () {
    for (let i = this.length - 1; i >= 0; i--) {
      if (this[i] && this[i].parentElement) {
        this[i].parentElement.removeChild(this[i])
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/main.js